module.exports = __webpack_public_path__ + "static/media/xiaomi_recent_2.5b0fac2c.jpg";